import React, { useState } from 'react'
import styles from './styles.module.css'
import TitleAndDesc from '../../components/TitleAndDesc/TitleAndDesc'
import Input from '../../components/Input'
import Textarea from '../../components/Textarea'
import { patientCard } from '../../assets/const'


export default function Main() {

    const [anketa, setAnketa] = useState(patientCard);

    const handleChange = (title, e) => {
        const {placeholder, value} = e;
        const newList = {...anketa, [title]: {...anketa[title], [placeholder]: value}};
        setAnketa(newList);
    }

    return (
        <div className={styles.wrapper}>

                <TitleAndDesc style={{marginTop: '1rem'}} title="Личная информация"/>

                <div className={styles.row} style={{width: '100%'}}>
                    <div className={styles.row} style={{width: '100%'}}>
                        <div className={styles.column}>
                            <Input placeholder='Имя' value={anketa['Личная информация']['Имя']} onChange={({target}) => handleChange('Личная информация', target)}/>
                            <Input placeholder='Возраст' value={anketa['Личная информация']['Возраст']} onChange={({target}) => handleChange('Личная информация', target)}/>
                        </div>
                        <div className={styles.column}>
                            <Input placeholder='Пол' value={anketa['Личная информация']['Пол']} onChange={({target}) => handleChange('Личная информация', target)}/>
                            <Input placeholder='Адрес' value={anketa['Личная информация']['Адрес']} onChange={({target}) => handleChange('Личная информация', target)}/>
                        </div>
                    </div>

                    <div className={styles.row} style={{width: '100%', marginTop: '1rem'}}>
                        <Textarea placeholder='Родственные связи' value={anketa['Личная информация']['Родственные связи']} onChange={({target}) => handleChange('Личная информация', target)}  propsstyle={{width: '100%'}}/>
                    </div>
                </div>
                
                <TitleAndDesc style={{marginTop: '1rem'}} title="Медицинская история"/>

                <div className={styles.row} style={{width: '100%'}}>
                    <div className={styles.row} style={{width: '100%'}}>
                        <div className={styles.column}>
                        <Textarea placeholder='Перенесенные заболевания или травмы' value={anketa['Медицинская история']['Перенесенные заболевания или травмы']} onChange={({target}) => handleChange('Медицинская история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Лечение' value={anketa['Медицинская история']['Лечение']} onChange={({target}) => handleChange('Медицинская история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Принимаемые лекарства' value={anketa['Медицинская история']['Принимаемые лекарства']} onChange={({target}) => handleChange('Медицинская история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                    </div>
                </div>
                
                <TitleAndDesc style={{marginTop: '1rem'}} title="Психологическая история"/>

                <div className={styles.row} style={{width: '100%'}}>
                    <div className={styles.row} style={{width: '100%'}}>
                        <div className={styles.column}>
                        <Textarea placeholder='Предыдущие психиатрические диагнозы и лечения' value={anketa['Психологическая история']['Предыдущие психиатрические диагнозы и лечения']} onChange={({target}) => handleChange('Психологическая история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Проблемы с психическим здоровьем' value={anketa['Психологическая история']['Проблемы с психическим здоровьем']} onChange={({target}) => handleChange('Психологическая история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Личный опыт жизни' value={anketa['Психологическая история']['Личный опыт жизни']} onChange={({target}) => handleChange('Психологическая история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Социальные отношения' value={anketa['Психологическая история']['Социальные отношения']} onChange={({target}) => handleChange('Психологическая история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                    </div>
                </div>
                
                <TitleAndDesc style={{marginTop: '1rem'}} title="Травматические события"/>

                <div className={styles.row} style={{width: '100%'}}>
                    <div className={styles.row} style={{width: '100%'}}>
                        <div className={styles.column}>
                        <Textarea placeholder='Дата и место события' value={anketa['Травматические события']['Дата и место события']} onChange={({target}) => handleChange('Травматические события', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Обстоятельства и последствия события' value={anketa['Травматические события']['Обстоятельства и последствия события']} onChange={({target}) => handleChange('Травматические события', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Ограничения в повседневной деятельности' value={anketa['Травматические события']['Ограничения в повседневной деятельности']} onChange={({target}) => handleChange('Травматические события', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Тревога или страх-ожидание' value={anketa['Травматические события']['Тревога или страх-ожидание']} onChange={({target}) => handleChange('Травматические события', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                    </div>
                </div>
                
                <TitleAndDesc style={{marginTop: '1rem'}} title="Симптомы ПТСР"/>

                <div className={styles.row} style={{width: '100%'}}>
                    <div className={styles.column} style={{width: '100%'}}>
                        <div className={styles.row} style={{width: '100%'}}>
                            <div className={styles.column}>
                            <Textarea placeholder='Чрезмерное воспоминание событий' value={anketa['Симптомы ПТСР']['Чрезмерное воспоминание событий']} onChange={({target}) => handleChange('Симптомы ПТСР', target)}  propsstyle={{width: '100%'}}/>
                            </div>
                            <div className={styles.column}>
                                <Textarea placeholder='Бессонница' value={anketa['Симптомы ПТСР']['Бессонница']} onChange={({target}) => handleChange('Симптомы ПТСР', target)}  propsstyle={{width: '100%'}}/>
                            </div>
                            <div className={styles.column}>
                                <Textarea placeholder='Кошмары' value={anketa['Симптомы ПТСР']['Кошмары']} onChange={({target}) => handleChange('Симптомы ПТСР', target)}  propsstyle={{width: '100%'}}/>
                            </div>
                            <div className={styles.column}>
                                <Textarea placeholder='Чувство вины и отчуждения' value={anketa['Симптомы ПТСР']['Чувство вины и отчуждения']} onChange={({target}) => handleChange('Симптомы ПТСР', target)}  propsstyle={{width: '100%'}}/>
                            </div>
                            </div>
                        
                        <div className={styles.row} style={{width: '100%'}}>
                            <div className={styles.column}>
                                <Textarea placeholder='Избегание ситуаций или мест, связанных с травмой' value={anketa['Симптомы ПТСР']['Избегание ситуаций или мест, связанных с травмой']} onChange={({target}) => handleChange('Симптомы ПТСР', target)}  propsstyle={{width: '100%'}}/>
                            </div>
                            <div className={styles.column}>
                                <Textarea placeholder='Вспышки ярости или агрессии' value={anketa['Симптомы ПТСР']['Вспышки ярости или агрессии']} onChange={({target}) => handleChange('Симптомы ПТСР', target)}  propsstyle={{width: '100%'}}/>
                            </div>
                            <div className={styles.column}>
                                <Textarea placeholder='Чувство опасности' value={anketa['Симптомы ПТСР']['Чувство опасности']} onChange={({target}) => handleChange('Симптомы ПТСР', target)}  propsstyle={{width: '100%'}}/>
                            </div>
                        </div>
                    </div>
                </div>
                
                <TitleAndDesc style={{marginTop: '1rem'}} title="Социальная история"/>

                <div className={styles.row} style={{width: '100%'}}>
                    <div className={styles.row} style={{width: '100%'}}>
                        <div className={styles.column}>
                        <Textarea placeholder='Занятость' value={anketa['Социальная история']['Занятость']} onChange={({target}) => handleChange('Социальная история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Семейные отношения и друзья' value={anketa['Социальная история']['Семейные отношения и друзья']} onChange={({target}) => handleChange('Социальная история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Уровень социальной поддержки' value={anketa['Социальная история']['Уровень социальной поддержки']} onChange={({target}) => handleChange('Социальная история', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                    </div>
                </div>
                
                <TitleAndDesc style={{marginTop: '1rem'}} title="Прошлые методы лечения ПТСР"/>

                <div className={styles.row} style={{width: '100%'}}>
                    <div className={styles.row} style={{width: '100%'}}>
                        <div className={styles.column}>
                        <Textarea placeholder='Оказание помощи в прошлом' value={anketa['Прошлые методы лечения ПТСР']['Оказание помощи в прошлом']} onChange={({target}) => handleChange('Прошлые методы лечения ПТСР', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Эффективность методов лечения' value={anketa['Прошлые методы лечения ПТСР']['Эффективность методов лечения']} onChange={({target}) => handleChange('Прошлые методы лечения ПТСР', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                    </div>
                </div>
                
                <TitleAndDesc style={{marginTop: '1rem'}} title="Социальные факторы"/>

                <div className={styles.row} style={{width: '100%'}}>
                    <div className={styles.row} style={{width: '100%'}}>
                        <div className={styles.column}>
                        <Textarea placeholder='Наличие дискриминации' value={anketa['Социальные факторы']['Наличие дискриминации']} onChange={({target}) => handleChange('Социальные факторы', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Уровень дохода или безработицы' value={anketa['Социальные факторы']['Уровень дохода или безработицы']} onChange={({target}) => handleChange('Социальные факторы', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                        <div className={styles.column}>
                            <Textarea placeholder='Безопасность жизни' value={anketa['Социальные факторы']['Безопасность жизни']} onChange={({target}) => handleChange('Социальные факторы', target)}  propsstyle={{width: '100%'}}/>
                        </div>
                    </div>
                </div>
        </div>
    )
}
